<template>
  <div class="instructions">
    <InstructionView class="instruction instruction1">
      <template v-slot:title>
        <h2>Instructions and explanations</h2>
      </template>
      <template v-slot:left>
        <div class="instruction_sub-title">
          <h3>Register as<br> a new member with Get24!</h3>
        </div>
        <div class="left_contents">
          <div class="contents">
            <div class="num one">Sign in with Google</div>
            <div class="num two">Sign in with Apple</div>
            <div class="num three">Register with Email</div>
          </div>
        </div>
        <img class="step_img" src="/img/how_to_play/4.png" alt="">
      </template>
      <template v-slot:right>
        <div class="tips_area">
          <div class="tips">Tips</div>
        </div>
        <div class="right_contents">
          <div class="right_title">Friend referral Campaign</div>
          <div class="contents">
            if you were referred by a friend, please enter the code after reg-istering as a member.
          </div>
          <div class="img">
            <img src="/img/how_to_play/5.png" alt="">
          </div>
        </div>
      </template>
    </InstructionView>

    <InstructionView :box2="true" class="instruction instruction2">
      <template v-slot:left>
        <div class="instruction_sub-title">
          <h3>Buy Gems</h3>
        </div>
        <div class="left_contents">
          <div class="contents">
            <div>You can purchase Gams<br>with these payment<br>methods</div>
            <img src="/img/how_to_play/7.png" alt="">
          </div>
        </div>
        <img class="gems" src="/img/how_to_play/8.png" alt="">
        <img class="step_img" src="/img/how_to_play/6.png" alt="">
      </template>
      <template v-slot:right>
        <div class="tips_area">
          <div class="tips">Tips</div>
        </div>
        <div class="right_contents">
          <div class="right_title">minny online store</div>
          <div class="contents">
            At minny online store, you can buy the cards you want with the Gems!<br>
            (*Gem is the same as Get24)<br>
            (*Login information is the same as Get24)
          </div>
          <div class="img">
            <img class="minny_img" src="/img/how_to_play/10.png" alt="">
            <img class="cart_img" src="/img/how_to_play/11.png" alt="">
          </div>
        </div>
        <img class="gem" src="/img/how_to_play/9.png" alt="">
      </template>
    </InstructionView>

    <InstructionView  :box3="true" class="instruction instruction3">
      <template v-slot:left>
        <div class="instruction_sub-title">
          <h3>choose the GACHA<br>that has the product you want.</h3>
        </div>
        <div class="left_contents">
          <img class="" src="/img/how_to_play/13.png" alt="">
        </div>
        <img class="step_img" src="/img/how_to_play/12.png" alt="">
      </template>
      <template v-slot:right>
        <div class="tips_area">
          <div class="tips">Tips</div>
        </div>
        <div class="right_contents">
          <div class="right_title">Choose<br>"Shipment Request"<br>or"Return to Gem".</div>
          <div>
            <img src="/img/how_to_play/14.png" alt="">
          </div>
        </div>
      </template>
    </InstructionView>
  </div>
</template>

<script>
import InstructionView from '@/components/atoms/InstructionView.vue';

export default {
  name: 'InstructionsView',
  components: {
    InstructionView,
  },
};
</script>

<style lang="scss" scoped>
.instructions {
  margin: 20px 10px 0;
  color: $white;
  .instruction {
    .tips_area {
      display: flex;
      .tips {
        background-color: $white;
        border-radius: 20px;
        color: #0094e3;
        padding: 0px 15px;
      }
    }
    h2 {
      text-align: center;
      font-size: 28px;
    }
    .instruction_sub-title {
      text-align: center;
      h3 {
        font-size: 24px;
        color: #ffff4d;
      }
    }
    .step_img {
      position: absolute;
      top: -20px;
      left: -10px;
      width: 15%;
    }
    .left_contents {
      margin-top: 10px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      .contents {
        font-size: 18px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
    .right_contents {
      .right_title {
        text-align: center;
        font-size: 22px;
        margin-bottom: 10px;
      }
      .contents {
        width: 90%;
        margin-left: auto;
      }
    }
  }
  .instruction1 {
    padding-top: 15px;
    z-index: 4;
    h2 {
      margin-bottom: 15px;
    }
    .right_contents {
      .img {
        text-align: end;
        margin-top: -15px;
        img {
          width: 35%;
          text-align: end;
        }
      }
    }
  }
  .instruction2 {
    padding-top: 30px;
    z-index: 3;
    .left_contents {
      .contents {
        text-align: left;
        div {
          margin: auto;
        }
        img {
          margin-top: 5px;
          position: initial;
          width: 100%;
        }
      }
    }
    .right_contents {
      .img {
        position: relative;
        .minny_img {
          position: absolute;
          width: 30%;
          top: 5px;
        }
        .cart_img {
          position: absolute;
          width: 35%;
          right: 45px;
          top: -20px;
        }
      }
    }
    .gems {
      position: absolute;
      top: 2%;
      right: 2%;
      width: 20%;
    }
    .gem {
      position: absolute;
      top: 15%;
      right: 3%;
      width: 5%;
    }
  }
  .instruction3 {
    padding-top: 30px;
    z-index: 2;
    .instruction_sub-title {
      h3 {
        font-size: 20px;
      }
    }
    .left_contents {
      img {
        width: 100%;
      }
    }
    .right_contents {
      div {
        text-align: center;
        img {
          width: 90%;
        }
      }
    }
  }
}
.one::before {
  content: '1';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.two::before {
  content: '2';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.three::before {
  content: '3';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
}
@media screen and (max-width: $tabletWidth) {
  .instructions {
    .instruction {
      .tips_area {
        display: flex;
        .tips {
          padding: 0px 10px;
          font-size: 12px;
        }
      }
      h2 {
        font-size: 24px;
      }
      .instruction_sub-title {
        h3 {
          font-size: 15px;
        }
      }
      .step_img {
        width: 20%;
      }
      .left_contents {
        .contents {
          font-size: 14px;
        }
      }
      .right_contents {
        .right_title {
          font-size: 11px;
          margin: 5px 0;
        }
        .contents {
          font-size: 10px;
        }
      }
    }
    .instruction1 {
      .right_contents {
        .img {
          margin-top: -18px;
          img {
            width: 30%;
          }
        }
      }
    }
    .instruction2 {
      padding-top: 20px;
      .left_contents {
        .contents {
          font-size: 12px;
        }
      }
      .right_contents {
        .contents {
          font-size: 8px;
        }
        .img {
          img {
            width: 30%;
          }
        }
      }
      .right_contents {
        .img {
          .minny_img {
            top: 5px;
          }
          .cart_img {
            right: 7px;
            top: -7px;
            width: 30%;
          }
        }
      }
      .gem {
        top: 18%;
        right: 5%;
      }
    }
    .instruction3 {
      padding-top: 20px;
      .instruction_sub-title {
        h3 {
          margin-top: 7px;
          font-size: 11px;
        }
      }
      .left_contents {
        img {
          width: 85%;
        }
      }
    }
  }
  .num {
    font-size: 12px;
  }
  .one::before {
    width: 15px;
    line-height: 15px;
  }
  .two::before {
    width: 15px;
    line-height: 15px;
  }
  .three::before {
    width: 15px;
    line-height: 15px;
  }
}
</style>
